import { memo } from "react";
import { styled } from "@mui/material/styles";
import MuiBox from "@mui/material/Box";
import { THEME_TYPES } from "constants/theme";
import ReportsTimeLine from "../ReportsTimeline";
import ConversationalLogs from "../ConversationalLogs";

const Box = styled(MuiBox)(({ theme }) => ({
  paddingBottom: theme.palette.mode === THEME_TYPES.DARK ? "20px" : 0
}));

const TabPanel = memo(({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      className="reports-timeline"
      hidden={value !== index}
      id={`horizontal-tabpanel-${index}`}
      aria-labelledby={`horizontal-tab-${index}`}
      style={{ height: "100%" }}
    >
      {value === index && <Box sx={{ height: "100%" }}>{children}</Box>}
    </div>
  );
});

const ExecutionTimelineLogs = ({ tabValue }) => {
  return (
    <>
      <TabPanel value={tabValue} index={0} key={`${0}-timeline`}>
        <ReportsTimeLine />
      </TabPanel>
      <TabPanel value={tabValue} index={1} key={`${1}-conversation-logs`}>
        <ConversationalLogs />
      </TabPanel>
    </>
  );
};

export default memo(ExecutionTimelineLogs);
